import React from "react";
import Banner from "../components/home/Banner";
import ImageWithContent from "../components/home/ImageWithContent";
import Service from "../components/home/Service";
import WeServe from "../components/home/industries_we_serve";
import KeyDifferent from "../components/home/KeyDifferentiators";
import Testimonial from "../components/home/testimonial";
import ContactUs from "../components/home/contact-us";
import Blog_Section from "../components/home/Blog_Section";

function HomePage() {
  return (
    <div className="App">
      <Banner />
      <ImageWithContent/>
      <Service />
      <WeServe />
      <KeyDifferent />
      <Testimonial/>
      <Blog_Section/>
      <ContactUs />
    </div>
  );
}

export default HomePage;
